import Connections from '../../connections';
import {
  action,
  observable,
} from 'mobx';
import {
  updatePhoneNumber,
  accumulation, 
  memberShipVerification,
  phoneNumberSelection,
  smsPhoneCodeVerification,
  phoneRegistration,
  renewalsDetails, 
  userDetails,
} from '../../axios/requests';
import { RequestStatus } from 'mobx-store';
import { MobileUser } from 'mobx-store/storeInterfaces/userManagmentInterface';
import { takeRightWhile } from 'lodash';
import { MemberRenewalDetails } from 'mobx-store/storeInterfaces/renewals.interface';
import { User } from 'mobx-store/storeInterfaces/statisticsInterface';

export class UserManagementStore {
  @observable state: RequestStatus = RequestStatus.IDLE;
  @observable mobileUser: MobileUser = {};
  @observable registrationRequest: {[key: string]: string} = {};
  @observable renewalsDetails: MemberRenewalDetails;
  @observable userDetails: User;
  constructor() {}

  @action.bound
  public async updateWalletPhoneNumber(userId: string, newPhoneNumber: string): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPut(updatePhoneNumber(userId), {
        newPhoneNumber
      });
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }
  @action.bound
  public async addOnlineUserAccumulation(userId: string, cashAmount: number): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPost(accumulation(userId), {
        cashAmount
      });
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }

  @action.bound
  public async memberShipVerification(membership: string): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      const membershipData = membership.split("_");
      this.registrationRequest.membershipId = membershipData[0];
      this.registrationRequest.sequenceNumber = membershipData[1];
      const { 
        data 
      } = await Connections.wadiDeglaAxios.httpPost(memberShipVerification, this.registrationRequest);
      this.mobileUser.firstMobile = data?.firstMobile;
      this.mobileUser.secondMobile = data?.secondMobile;
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      console.log('error', error);
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }

  @action.bound
  public async phoneNumberSelection(type: string): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      this.registrationRequest.phoneType = type;
      await Connections.wadiDeglaAxios.httpPost(phoneNumberSelection, this.registrationRequest);
  
      await Connections.wadiDeglaAxios.httpPost(smsPhoneCodeVerification, this.registrationRequest);
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      console.log('error', error);
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }
  @action.bound
  public async registerMobileUser(email: string, password: string): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      this.registrationRequest.email = email;
      this.registrationRequest.password = password;

      await Connections.wadiDeglaAxios.httpPost(phoneRegistration, this.registrationRequest);
      
      this.state = RequestStatus.SUCCESS;
      this.registrationRequest = {};
    } catch (error) {
      console.log('error', error);
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }
  @action.bound
  public async getUserRenewals(userId: number): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(renewalsDetails(userId));
      this.renewalsDetails = response.data
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }

  @action.bound
  public async getUserDetails(userId: number): Promise<void> {
    try {
      this.state = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(userDetails(userId));
      this.userDetails = response.data
      this.state = RequestStatus.SUCCESS;
    } catch (error) {
      this.state = RequestStatus.FAILED;
      return Promise.reject(error?.response?.data?.message);
    }
  }
  
}
